export const API_HOST = process.env.REACT_APP_API_HOST
export const API_HOST_LOGIN = process.env.REACT_APP_API_HOST_LOGIN